
  import {Component, Prop, Vue} from "vue-property-decorator";
  import {CustomApexChart} from "@/plugins/apexcharts";
  import {IDashboard} from "@/modules/Dashboard/interfaces/dashboard.interface";
  import _ from 'lodash';
  import moment from "moment";
  import {isMobileOnly} from "mobile-device-detect";
  import {IApp} from "@/interfaces/app.interface";

  @Component({})
  export default class MonthsDashboard extends Vue {

    @Prop() chartType: string;
    @Prop() theme: string;

    get dashboardData(): IDashboard.IByYearData[] { return this.$store.state.dashboard.dashboards[this.chartData[this.chartType]];}
    get apexChartName() { return `apexchart-dashboard-months-${this.chartData[this.chartType]}` }
    get displayChart() { return this.dashboardData.some(item => item[this.chartType] > 0); }

    isMobile = isMobileOnly;
    updateChartInterval = null;
    chartData = {
      [IDashboard.MonthChartType.Sum]: 'sumByYears',
      [IDashboard.MonthChartType.Count]: 'countByYears',
    };
    chartTitle = {
      [IDashboard.MonthChartType.Sum]: 'Сумма',
      [IDashboard.MonthChartType.Count]: 'Количество',
    };
    chart = null;
    series = [];
    isLoading: boolean = true;
    options: any = null;

    created() {
      if (!this.displayChart) return;

      this.initOptions();
      this.prepareData();
      this.chart = new CustomApexChart(`.${this.apexChartName}`, this.options);
    }

    initOptions() {
      this.options = {
        chart: {
          type: 'bar',
          height: '100%',
          width: '100%',
          toolbar: { show: false },
        },
        theme: {
          mode: this.theme,
        },
        series: [],
        dataLabels: {
          formatter: (value) =>
            Math.trunc(value / 1000) > 0 && value > 10000
              ? (value / 1000).toFixed(0) + ' к'
              : value > 0 ? this.$options.filters.currency(value, this.chartType === IDashboard.MonthChartType.Sum ? '₽' : '', ' ', 0) : '',
          style: {
            colors: ['#fff'],
            style: {
              fontSize: '14px',
            },
          },
          // offsetY: -20,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '90%',
          },
        },
        grid: { show: false },
        xaxis: {
          categories: [],
          labels: {
            style: {
              colors: ['#000'],
              fontSize: '14px',
            },
          },
        },
        yaxis: { show: false },
        fill: { opacity: 1 },
        tooltip: {
          y: {
            formatter: (value) => this.$options.filters.currency(value, this.chartType === IDashboard.MonthChartType.Sum ? '₽' : '', ' ', 0),
          }
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          fontSize: '14px',
          markers: {
            radius: 12
          }
        },
      };
    }

    prepareData() {
      this.series = [];
      let monthsNumber = {};
      let years = [];
      this.dashboardData.forEach(item  => {
        if (!monthsNumber[item.month]) monthsNumber[item.month] = {};
        monthsNumber[item.month][item.year] = item[this.chartType];
        years.push(item.year);
      });
      let months = {};
      Object.keys(monthsNumber).forEach(monthValue => {
        let monthsStr = moment('01.01.2024', 'DD.MM.YYYY').add(+monthValue - 1, 'months').format('MMM');
        Vue.set(months, monthsStr, monthsNumber[monthValue]);
      });

      years = _.sortBy(_.union(years));
      let items = [
        { label: '3 года назад', prop: years[0], color: '#595454', },
        { label: '2 года назад', prop: years[1], color: '#b7b7b7', },
        { label: 'Прошлый', prop: years[2], color: '#EE7E4E', },
        { label: 'Текущий', prop: years[3], color: '#00953F', },
      ];
      let data = Object.entries(months).map(month => month[1]);

      items.forEach(item => {
        if (this.isMobile) {
          let currentYear = +moment().format('YYYY');
          if (item.prop < currentYear - 1) return;
        }

        let arr = data.map(values => values[item.prop] ? values[item.prop] : 0);
        let sum = arr.reduce((sum, cur) => sum + cur);

        if (sum) {
          this.series.push({ name: item.label, data: arr, color: item.color });
        }
      });

      this.options.series = this.series;
      this.options.xaxis.categories = Object.entries(months).map(month => month[0]);
      this.options.xaxis.labels.style.colors = Object.keys(months)
        .map(month => month === moment().format('MMM') ? '#EE7E4E' : this.theme === IApp.ThemeName.Light ? '#000' : '#ffffffb8');

      this.options.chart.events = {
        mounted: () => {
          this.updateColorForCurrentMonth();
        },
      };
    }

    updateColorForCurrentMonth() {
      let currentMonth = Number(moment().format('MM'));
      let columns: any = document.querySelectorAll(`.${this.apexChartName} .apexcharts-canvas g.apexcharts-series`);
      if (columns && columns.length) {
        let currentYear: any = columns[columns.length - 1].childNodes;
        let currentMonthColumn = currentYear[currentMonth - 1];
        if (currentMonthColumn) currentMonthColumn.setAttribute('fill', '#008ffb');
      }
    }

    updateChart() {
      if (!this.displayChart) return;

      this.prepareData();
      if (this.chart.chart) {
        this.chart.chart.updateSeries(this.options.series);
        this.updateColorForCurrentMonth();
      }
      else {
        this.updateChartInterval = setInterval(() => {
          if (this.chart.chart) {
            this.chart.chart.updateSeries(this.options.series);
            this.updateColorForCurrentMonth();

            clearInterval(this.updateChartInterval);
          }
        }, 100);
      }
    }

    destroyed() {
      if (this.chart) this.chart.destroyChart();
    }
  }
